var DescriptionsItem = function (props) {
    return props.children;
};
DescriptionsItem.displayName = 'DescriptionsItem';
export default DescriptionsItem;
//# sourceMappingURL=descriptions-item.js.map